// convention for constants is
// [App_Name]_[Action]
var ViewerConstants: IViewerConstants = {
    KNOWLEDGE_VIEW_OPEN: 'KNOWLEDGE_VIEW_OPEN',
    KNOWLEDGE_VIEW_CLOSE: 'KNOWLEDGE_VIEW_CLOSE',
    KNOWLEDGE_VIEW_SET_DATA: 'KNOWLEDGE_VIEW_SET_DATA',
    KNOWLEDGE_VIEW_SET_DIRTY: 'KNOWLEDGE_VIEW_SET_DIRTY',
    VIEWER_SET_CAMERA_PROPERTIES: 'VIEWER_SET_CAMERA_PROPERTIES',
    VIEWER_SET_RANGE_POSITION: 'VIEWER_SET_RANGE_POSITION',
    VIEWER_UPDATE_RANGE_POSITION: 'VIEWER_UPDATE_RANGE_POSITION',
    VIEWER_SET_3DCAMERA_PROPERTIES: 'VIEWER_SET_3DCAMERA_PROPERTIES',
    VIEWER_SET_DISPLAY_OBSTRUCTED_TAGS: 'VIEWER_SET_DISPLAY_OBSTRUCTED_TAGS',
    VIEWER_SET_VISIBLE_ASSET_TAG_CLASSES: 'VIEWER_SET_VISIBLE_ASSET_TAG_CLASSES',
    VIEWER_SHOW_IMAGE: 'VIEWER_SHOW_IMAGE',
    VIEWER_SHOW_ONTOLOGY_3D: 'VIEWER_SHOW_ONTOLOGY_3D',
    VIEWER_HIDE_IMAGE: 'VIEWER_HIDE_IMAGE',
    VIEWER_SET_DISPLAY_MODE: 'VIEWER_SET_DISPLAY_MODE',
    VIEWER_RESET_CAMERA_PROPERTIES: 'VIEWER_RESET_CAMERA_PROPERTIES',
    VIEWER_SET_ASSEMBLY_CREATION_TEMPLATE: 'VIEWER_SET_ASSEMBLY_CREATION_TEMPLATE',
    VIEWER_SET_MEASUREMENT_TYPE: 'VIEWER_SET_MEASUREMENT_TYPE',
    VIEWER_ADD_ANNOTATION: 'VIEWER_ADD_ANNOTATION',
    VIEWER_REFRESH_MEASUREMENT: 'VIEWER_REFRESH_MEASUREMENT',
    VIEWER_SAVE_MEASUREMENT: 'VIEWER_SAVE_MEASUREMENT',
    VIEWER_SAVE_ASSEMBLY_INSTANCE: 'VIEWER_SAVE_ASSEMBLY_INSTANCE',
    VIEWER_DELETE_MEASUREMENT: 'VIEWER_DELETE_MEASUREMENT',
    VIEWER_EDIT_ANNOTATION: 'VIEWER_EDIT_ANNOTATION',
    VIEWER_ADD_MEASUREMENT: 'VIEWER_ADD_MEASUREMENT',
    VIEWER_ADD_ASSEMBLY: 'VIEWER_ADD_ASSEMBLY',
    VIEWER_REMOVE_ASSEMBLY: 'VIEWER_REMOVE_ASSEMBLY',
    VIEWER_ADD_ASSEMBLIES: 'VIEWER_ADD_ASSEMBLIES',
    VIEWER_SET_ASSEMBLIES: 'VIEWER_SET_ASSEMBLIES',
    VIEWER_ADD_ASSEMBLY_INSTANCE: 'VIEWER_ADD_ASSEMBLY_INSTANCE',
    VIEWER_DELETE_ANNOTATION: 'VIEWER_DELETE_ANNOTATION',
    VIEWER_SELECT_ASSEMBLY: 'VIEWER_SELECT_ASSEMBLY',
    VIEWER_SELECT_ANNOTATIONS: 'VIEWER_SELECT_ANNOTATIONS',
    VIEWER_SELECT: 'VIEWER_SELECT',
    VIEWER_UPDATE_ANNOTATION: 'VIEWER_UPDATE_ANNOTATION',
    VIEWER_UPDATE_SELECTED_ASSEMBLY_BOUNDS: 'VIEWER_UPDATE_SELECTED_ASSEMBLY_BOUNDS',
    VIEWER_UPDATE_ASSEMBLY: 'VIEWER_UPDATE_ASSEMBLY',
    VIEWER_UPDATE_SETTING: 'VIEWER_UPDATE_SETTING',
    VIEWER_SET_MULTIPLE_SELECTION_ENABLED: 'VIEWER_SET_MULTIPLE_SELECTION_ENABLED',
    VIEWER_DEPTH_LOADED: 'VIEWER_DEPTH_LOADED',
    VIEWER_MINI_MAP_OPEN: 'VIEWER_MINI_MAP_OPEN',
    VIEWER_MINI_MAP_POSITIONS: 'VIEWER_MINI_MAP_POSITIONS',
    VIEWER_MINI_MAP_SIZE: 'VIEWER_MINI_MAP_SIZE',
    VIEWER_MINI_MAP_FULL_SCREEN: 'VIEWER_MINI_MAP_FULL_SCREEN',
    VIEWER_SHOW_LOD: 'VIEWER_SHOW_LOD',
    VIEWER_SET_SPEEDDIAL: 'VIEWER_SET_SPEEDDIAL',
    VIEWER_SET_OPEN_POINT_CLOUD: 'VIEWER_SET_OPEN_POINT_CLOUD',
    VIEWER_SET_POINT_CLOUD_LOADED: 'VIEWER_SET_POINT_CLOUD_LOADED',
    VIEWER_SET_POINT_CLOUD_DATA: 'VIEWER_SET_POINT_CLOUD_DATA',
    VIEWER_SHOW_ANNOTATIONS: 'VIEWER_SHOW_ANNOTATIONS',
    VIEWER_FOCUS_ANNOTATION: 'VIEWER_FOCUS_ANNOTATION',
    VIEWER_FOCUS_HIERARCHY_ITEM: 'VIEWER_FOCUS_HIERARCHY_ITEM',
    VIEWER_FOCUS_MEASUREMENT: 'VIEWER_FOCUS_MEASUREMENT',
    VIEWER_RECEIVE_SETTINGS: 'VIEWER_RECEIVE_SETTINGS',
    SET_ANNOTATION_EDITOR_MODE: 'SET_ANNOTATION_EDITOR_MODE',
    VIEWER_RESET_ANNOTATION: 'VIEWER_RESET_ANNOTATION',
    CAMERA_SET_DIRTY: 'CAMERA_SET_DIRTY',
    UPDATE_VIEWER_DIRECTION: 'UPDATE_VIEWER_DIRECTION',
    VIEWER_CONTENT_TYPES: 'VIEWER_CONTENT_TYPES',
    SET_ATTRIBUTES_INFORMATION: 'SET_ATTRIBUTES_INFORMATION',
    ASSETS_ATTRIBUTES_RECEIVE_DETAILS: 'ASSETS_ATTRIBUTES_RECEIVE_DETAILS',
    VIEWER_EDIT_ASSET_TAG: 'VIEWER_EDIT_ASSET_TAG',
    VIEWER_UPDATE_MEASUREMENTS: 'VIEWER_UPDATE_MEASUREMENTS',
    VIEWER_RELOAD_MEASUREMENT: 'VIEWER_RELOAD_MEASUREMENT',
    ASSET_TAGS_FILTER: 'ASSET_TAGS_FILTER',
    ASSET_PANEL_VISIBILITY: 'ASSET_PANEL_VISIBILITY',
    SET_SELECTED_ASSEMBLY_TEMPLATE: 'SET_SELECTED_ASSEMBLY_TEMPLATE',
    SET_CONTENT_LAYERS: 'SET_CONTENT_LAYERS',
    ASSEMBLY_SET_DIRTY: 'ASSEMBLY_SET_DIRTY',
    UNDO_ASSEMBLY: 'UNDO_ASSEMBLY',
    UPDATE_ASSEMBLIES: 'UPDATE_ASSEMBLIES',
    ASSEMBLY_INSTANCE_UPDATE: 'ASSEMBLY_INSTANCE_UPDATE',
    HIERARCHYITEM_SELECT: 'HIERARCHYITEM_SELECT',
    HIERARCHYITEMS_SELECT: 'HIERARCHYITEMS_SELECT',
    MESHITEM_SELECT: 'MESHITEM_SELECT',
    ASSET_SET_SELECT: 'ASSET_SET_SELECT',
    KNOWLEDGE_VIEW_RENAME: 'KNOWLEDGE_VIEW_RENAME',
} as const;

export default ViewerConstants;
